import React, { Component } from "react";
import {Button, Col, Form, Input, Modal, Row, Alert} from "antd";
import {injectIntl} from "react-intl";
import './ErrorModal.css';
import {signin} from "../../actions/AuthAction";
import {connect} from "react-redux";
import {
  sendNotification,
  USER_DISABLED, USER_DISABLED_CODE,
  USER_INACTIVE,
  USER_INACTIVE_CODE, USER_LOGIN_ATTEMPS_DISABLED_CODE,
  USER_LOGIN_TIME_ATTEMPS_DISABLED,
  USER_NOT_FOUND_RECOVERY
} from "../../utils";
import {withRouter} from "react-router-dom";
import BunkeyAPI from '../../api/BunkeyAPI';
import PrivacyAndTermsFooter from "./PrivacyAndTermsFooter";
import { freePlanPrice } from "../../utils/constants";

class VerifyCodeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: "",
      generatingPaymentLink: false
    }
  }
  openInNewTab = (url) => {
    window.open(url, "_self", "noreferrer");
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {isFetching: isFetchingOld} = prevProps;
    const { user, token, signUpResponse, intl, isFetching, error} = this.props;

    if (token && user && user.role) {
      BunkeyAPI({
        url: `clients/${signUpResponse._id || 1}/plangolocal`,
        method: 'POST',
        data: {
          "name": signUpResponse.companyName,    
          "amount": freePlanPrice
        }
      }).then(resp => {
        const {url} = resp.data;
        this.openInNewTab(url);
        this.props.handleHiddenModal();
        this.props.handleShowCloseWindowModal();
      }).catch(err => {
        sendNotification('success', intl, `Ocurrió un error al generar el pago`)
      })
    }
    if(isFetchingOld && !isFetching && error){
      this.setState({
        generatingPaymentLink: false
      });
    }
  }
  handleSubmit = (e) => {
    const {email} = this.props.userData;
    const { code: password } = this.state
    e.preventDefault();

    this.setState({
      generatingPaymentLink: true
    });

    this.props.signin({ email, password, fromSignUp: true });


  }
  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      error,
      userData,
      isFetching,
      handlecloseverifycode,
    } = this.props;

    const  {
      generatingPaymentLink
    } = this.state

    const hash = '#'

    return (
      <React.Fragment>
        <Modal
          visible={showModal}
          onCancel={handleHiddenModal}
          width={540}
          footer={null}
          centered
        >
          <Row justify={'center'}>
            <Col span={24} style={{ textAlign: 'center', }}>
              <div style={{ fontSize: 21, fontWeight: 600, color: '#000000', }}>{intl.formatMessage({ id: 'VerifyCodeModal_EnterCode1' })}</div>
              <div style={{ color: '#3598CD', fontSize: 20, fontWeight: 400, }}>{userData.email}</div>
              <div><span style={{ color: '#8D8D8D', fontSize: 13, }}>{intl.formatMessage({ id: 'VerifyCodeModal_Question' })}</span> <a href={hash} onClick={handlecloseverifycode}>Cambiar correo</a></div>
            </Col>
          </Row>
          <br/>
          <Form>
            <Form.Item>
              <label style={{ fontSize: 16, fontWeight: 400, }}>{intl.formatMessage({ id: 'VerifyCodeModal_EnterCode' })}</label>
              <Input
                size={'large'}
                placeholder={'******'}
                style={{ height: 57, }}
                className={'input-code-verify'}
                value={this.state.code}
                onChange={(e)=> {
                  this.setState({
                    code: e.target.value
                  })
                }}
              />
            </Form.Item>
          </Form>
          <Row>
            <Button
              size={'large'}
              type={'primary'}
              block
              style={{ height: 57, }}
              loading={isFetching || generatingPaymentLink}
              onClick={(e=>{
                if(this.state.code === ""){
                  sendNotification('warning', intl, intl.formatMessage({ id: 'VerifyCodeModal_verification' }));
                  return;
                }
                this.handleSubmit(e)
              })}
            >
              {intl.formatMessage({ id: 'VerifyCodeModal_Start' })}
            </Button>
          </Row>
          <br/>
          <div style={{ marginBottom: 10 }}>
            {error && error.status !== USER_NOT_FOUND_RECOVERY && error.status !== USER_DISABLED && <Alert
              style={{ display: 'flex', justifyContent: 'center' }}
              message={
                error && error.data && error.data.message <= 0
                  ? intl.formatMessage({ id: 'login_attemps_disable_user' }).replace('#time', USER_LOGIN_TIME_ATTEMPS_DISABLED)
                  : error.data && error.data.message
                    ? intl.formatMessage({ id: 'login_not_valid' }).replace('#attemps', error.data.message)
                    : intl.formatMessage({ id: 'login_not_valid' }).slice(0, 33)
              }
              type="error"
            />}
            {error && error.status === USER_INACTIVE && error.data.code === USER_INACTIVE_CODE && <Alert
              style={{ display: 'flex', justifyContent: 'center' }}
              message={intl.formatMessage({ id: 'current_user_is_inactive' }) + ' ' + intl.formatMessage({ id: 'current_user_is_inactive_contact' })}
              type="error"
            />}
            {error && error.status === USER_DISABLED && error.data.code === USER_DISABLED_CODE && <Alert
              style={{ display: 'flex', justifyContent: 'center' }}
              message={intl.formatMessage({ id: 'current_user_is_disabled' }) + ' 23:59 hrs. ' + intl.formatMessage({ id: 'from' }) + ' ' +
                error.data.message.replace(/"/g, '') + '. ' + intl.formatMessage({ id: 'current_user_is_disabled_contact' })}
              type="error"
            />}
            {error && error.status === USER_DISABLED && error.data.code === USER_LOGIN_ATTEMPS_DISABLED_CODE && <Alert
              style={{ display: 'flex', justifyContent: 'center' }}
              message={intl.formatMessage({ id: 'login_attemps_disable_user' }).replace('#time', error.data.message)}
              type="error"
            />}
          </div>
          <PrivacyAndTermsFooter/>
        </Modal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    error: state.authUser.error,
    token: state.authUser.token,
    isFetching: state.authUser.isFetching,
  }
}

const mapDispatchToProps = {
  signin,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyCodeModal)))
